export const conversation = () => (
  <path
    d="M12 9.803A6 6 0 0015 21h6s-.75-.72-1.773-1.742A5.982 5.982 0 0021 15c0-2.22-1.207-4.16-3-5.197M6 15H3s.75-.72 1.773-1.742a6 6 0 117.545.742"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
